import APIService from '../../services/api'
import { getCatalogs } from '../../services/data'

export const OPEN_SECTION_DIALOG = 'OPEN_SECTION_DIALOG'
export const OPEN_SECTION_ID_DIALOG = 'OPEN_SECTION_ID_DIALOG'
export const OPEN_CATALOG_DIALOG = 'OPEN_CATALOG_DIALOG'

export const GET_CATALOG = 'GET_CATALOG'
export const FETCH_CATALOG = 'FETCH_CATALOG'
export const FETCH_SECTION = 'FETCH_SECTION'
export const UPDATE_CATALOG = 'UPDATE_CATALOG'

export const GET_EXHIBITOR_DETAIL = 'GET_EXHIBITOR_DETAIL'
export const FETCH_EXHIBITOR_DETAIL = 'FETCH_EXHIBITOR_DETAIL'
export const UPDATE_EXHIBITOR_DETAIL = 'UPDATE_EXHIBITOR_DETAIL'

export const GET_EXHIBITED_WORK = 'GET_EXHIBITED_WORK'
export const FETCH_EXHIBITED_WORK_DETAIL = 'FETCH_EXHIBITED_WORK_DETAIL'
export const UPDATE_EXHIBITED_WORK_DETAIL = 'UPDATE_EXHIBITED_WORK_DETAIL'

export const ERROR_API = 'ERROR_API'

export const actionsCatalog = {
  [OPEN_SECTION_DIALOG] ({commit},
    { section }) {
    commit(OPEN_SECTION_DIALOG, {
      visible: true,
      section: section
    })
  },
  [OPEN_SECTION_ID_DIALOG] ({commit, dispatch}, { id }) {
    commit(FETCH_SECTION)
    APIService.searchExhibitionSection({
      transform: true,
      filters: [
        {
          property: 'id',
          matchType: 'eq',
          value: id
        }
      ],
      satisfy: 'all'
    }).then(json => {
      const section = json.visu_exhibition_section[0]
      section.exhibitors = {}
      commit(OPEN_SECTION_DIALOG, {
        visible: true,
        section
      })
      dispatch(GET_EXHIBITOR_DETAIL, {
        sectionId: section.id,
        objectToIncrement: section.exhibitors
      })
    }).catch((err) => {
      commit(ERROR_API, {
        error: err
      })
    })
  },
  [OPEN_CATALOG_DIALOG] ({commit}) {
    commit(OPEN_CATALOG_DIALOG, {
      visible: true
    })
  },
  [GET_CATALOG] ({commit, state},
    { id }) {
    commit(FETCH_CATALOG)
    APIService.searchExhibitionSection({
      transform: true,
      filters: [
        {
          property: 'id_exhibition',
          matchType: 'eq',
          value: id
        }
      ],
      order: {
        column: 'id',
        direction: 'ASC'
      },
      satisfy: 'all'
    }).then(json => {
      const catalogs = getCatalogs(json.visu_exhibition_section)
      commit(UPDATE_CATALOG, {
        results: catalogs || []
      })
    }).catch((err) => {
      commit(ERROR_API, {
        error: err
      })
    })
  },
  [GET_EXHIBITOR_DETAIL] ({commit, state},
    { objectToIncrement, sectionId }) {
    commit(FETCH_EXHIBITOR_DETAIL, {
      objectToIncrement
    })
    let filters = []
    sectionId && filters.push({
      property: 'id_exhibition_section',
      matchType: 'eq',
      value: sectionId
    })

    APIService.searchExhibitor({
      transform: true,
      filters,
      satisfy: 'all'
    }).then(json => {
      commit(UPDATE_EXHIBITOR_DETAIL, {
        results: json.visu_exhibitor || [],
        objectToIncrement
      })
    }).catch((err) => {
      commit(ERROR_API, {
        error: err
      })
    })
  },
  [GET_EXHIBITED_WORK] ({commit, state},
    { objectToIncrement, sectionId, exhibitorId }) {
    commit(FETCH_EXHIBITED_WORK_DETAIL, {
      objectToIncrement
    })
    let filters = []
    sectionId && filters.push({
      property: 'id_exhibition_section',
      matchType: 'eq',
      value: sectionId
    })
    exhibitorId && filters.push({
      property: 'id_exhibitor',
      matchType: 'eq',
      value: exhibitorId
    })

    APIService.searchExhibitedWork({
      transform: true,
      filters,
      satisfy: 'all'
    }).then(json => {
      commit(UPDATE_EXHIBITED_WORK_DETAIL, {
        results: json.visu_exhibited_work || [],
        objectToIncrement
      })
    }).catch((err) => {
      commit(ERROR_API, {
        error: err
      })
    })
  }
}

export default actionsCatalog



// WEBPACK FOOTER //
// ./src/store/dialog/actions.js